function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.621 0H3.378A3.48 3.48 0 000 3.48v11.04A3.5 3.5 0 003.494 18H20.5a3.577 3.577 0 003.5-3.48V3.48A3.556 3.556 0 0020.621 0zm-7.456 9.06c-.12.12-.12.12-.233.12a3.851 3.851 0 01-1.631 0l-.12-.12c-.12 0-.233-.12-.35-.12h-.12l-8.16-7.2c.35-.12.583-.12.931-.233H20.5a1.32 1.32 0 01.932.348zM9.9 10.1c.12 0 .12.12.233.12l.12.12h.12a4.895 4.895 0 001.747.456 3.11 3.11 0 001.4-.348.408.408 0 00.233-.12l.12-.12 6.757 6.271H3.145zm5.359-.929l7.11-6.156v11.849h.12a1.646 1.646 0 01-.233.7zm-6.408 0L1.864 15.56a1.87 1.87 0 01-.35-1.045V3.48a1.044 1.044 0 01.12-.581z",
  fill: "#8498a3"
});

var SvgPartsMail = function SvgPartsMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18
  }, props), _ref);
};

export default SvgPartsMail;